// extracted by mini-css-extract-plugin
export const root = "AllInclusiveBox-module--root--1WHae";
export const container = "AllInclusiveBox-module--container--qUAx2";
export const header = "AllInclusiveBox-module--header--3HyHR";
export const headerTitle = "AllInclusiveBox-module--header-title--1NNxx";
export const headerContent = "AllInclusiveBox-module--header-content--2s3zm";
export const body = "AllInclusiveBox-module--body--3ZsHF";
export const tabs = "AllInclusiveBox-module--tabs--TRmAp";
export const tabList = "AllInclusiveBox-module--tab-list--32e27";
export const tab = "AllInclusiveBox-module--tab--3Uc4X";
export const tabPanel = "AllInclusiveBox-module--tab-panel--3RBXC";
export const tabPanelSelected = "AllInclusiveBox-module--tab-panel-selected--M972j";
export const tabPanelFooter = "AllInclusiveBox-module--tab-panel-footer--1HQBV";
export const sscButton = "AllInclusiveBox-module--ssc-button--TZrk0";
export const features = "AllInclusiveBox-module--features--3XTRx";
export const featureContent = "AllInclusiveBox-module--feature-content--329dI";
export const featureContentHighlighted = "AllInclusiveBox-module--feature-content-highlighted--1KE08";
export const featureIcon = "AllInclusiveBox-module--feature-icon--2qma_";
export const featureContentTitle = "AllInclusiveBox-module--feature-content-title--2XuW5";
export const featureContentDescription = "AllInclusiveBox-module--feature-content-description--2DUoF";
export const featureContentList = "AllInclusiveBox-module--feature-content-list--fN1h7";
export const footerDisclaimer = "AllInclusiveBox-module--footer-disclaimer--3b5zL";
export const footer = "AllInclusiveBox-module--footer--2rCyc";